import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {IMultiSelectRequest, IMultiSelectResponse, ISelectRequest, ISelectResponse} from '../models/dynamic-form.model';

@Injectable({
  providedIn: 'root',
})
export class DynamicFormService {
  private readonly _httpClient = inject(HttpClient);


  getMultiSelectOptions(request: IMultiSelectRequest): Observable<IMultiSelectResponse> {
    return this._httpClient.get<IMultiSelectResponse>(
      `${environment.api.baseUrl}/${request.apiEndpointUrl}?q=${request.q}&page=${request.page}&limit=${request.limit}`
    );
  }

  getSelectOptions(request: ISelectRequest): Observable<ISelectResponse[]> {
    if (request.filterAtClient) {
      return this._httpClient.get<ISelectResponse[]>(`${environment.api.baseUrl}/${request.apiEndpointUrl}`);
    } else {
      return this._httpClient.get<ISelectResponse[]>(
        `${environment.api.baseUrl}/${request.apiEndpointUrl}?q=${request.q}&page=${request.page}&limit=${request.limit}`
      );
    }
  }
}
